import Button from './Button';

export default Button;

export type ButtonVariant =
  | 'solid'
  | 'outline'
  | 'soft'
  | 'link'
  | 'error'
  | 'transparent'
  | 'error-beelajar';

export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonType = 'button' | 'submit' | 'reset';

export type ButtonProps = {
  variant?: ButtonVariant;
  linkTo?: string;
  className?: string;
  full?: boolean;
  loading?: boolean;
  disabled?: boolean;
  type?: ButtonType;
  children?: React.ReactNode;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  styles?: React.CSSProperties;
  size?: ButtonSize;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};
